<template>
    <div class="texts">
        <div class="tip">
            <el-alert
                    title="温馨提示"
                    type="success"
                    close-text="知道了"
                    show-icon>
                <p>如果不开启，则下面文案不会发送</p>
                <p>微信对发送消息有数量限制，建议发送一条文本消息</p>
                <p>支持发送多个文案</p>
            </el-alert>
        </div>
        <div class="title" @click.stop>
            <span>是否开启：</span>
            <el-switch v-model="item.open"></el-switch>
        </div>
        <div class="">
            <el-form :model="item" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item class="item" v-for="(text,index) in item.texts"
                              :label="'第' + (index+1)+'条文案'"
                              :key="'text'+index"
                              :prop="'texts.'+index+'.text'"
                              :rules="{
                    required: true, message: '文案不能为空', trigger: 'blur'}">
                    <el-input class="input"
                              type="textarea"
                              autosize
                              :rows="2"
                              placeholder="请输入文案"
                              v-model="text.text">
                    </el-input>
                    <el-button type="primary" @click="newText(index)" size="mini">加一条</el-button>
                    <el-popover
                            placement="right"
                            width="160"
                            v-model="text.visible">
                        <p>确定删除吗？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="info" @click="text.visible = false">取消</el-button>
                            <el-button type="danger" size="mini" @click="deleteText(index,text)">确定</el-button>
                        </div>
                        <el-button slot="reference" type="danger" size="mini">删除</el-button>
                    </el-popover>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-button type="primary" @click.prevent="saveTexts('ruleForm')">保存</el-button>
                    </el-col>
                </el-row>
            </el-form>

        </div>
    </div>

</template>
<script>
    import {mediaActivityApi} from "../../common/mediaActivityApi";

    export default {
        name: "text-list",
        props: {
            mediaActivityId: {
                type: Number
            },
            sort: {
                type: Number
            },
            mpAuthConfigId: {
                type: Number
            }
        },

        watch: {
            mpAuthConfigId() {

            },
            mediaActivityId() {
                this.onload();

            }

        },
        data() {
            return {
                deleteDialogShow: false,
                item: {texts: [{'text': ''}], mediaActivityId: this.mediaActivityId, sort: this.sort},
            }
        },
        created() {

        },
        mounted() {
            this.onload();
            var that = this
            if (!that.mpAuthConfigId) {
                that.$message({
                    showClose: true,
                    message: '请先点击最上面开启按钮，再点击右侧箭头，并保存以后再操作。',
                    type: 'error'
                });
                return false;
            }
        },

        methods: {
            onload() {
                var that = this
                mediaActivityApi.getMediaActivityTexts.call(that, {
                    mpAuthConfigId: that.mpAuthConfigId,
                    mediaActivityId: that.mediaActivityId,
                    sort: that.sort
                }, function (res) {
                    if (res.result.data) {
                        for (var i = 0; i < res.result.data.length; i++) {
                            var text = res.result.data[i]
                            if (that.sort == text.sort) {
                                text.texts = JSON.parse(text.replyContent)
                                if (text.texts && text.texts.length > 0) {
                                    that.item = text;
                                    break
                                }
                            }
                        }
                        if (res.result.data.length < 1) {
                            that.item = {texts: [{'text': ''}], mediaActivityId: that.mediaActivityId, sort: that.sort}
                        }
                    }
                })
            },
            newText(index) {
                this.item.texts.splice(index + 1, 0, {"text": "", visible: false})
            },
            deleteText(index, text) {
                this.item.texts.splice(index, 1)
                text.visible = false
            },
            saveTexts(formName) {
                var that = this
                if (!that.mpAuthConfigId) {
                    that.$message({
                        showClose: true,
                        message: '请先点击最上面开启按钮，再点击右侧箭头，并保存以后再操作。',
                        type: 'error'
                    });
                    return false;
                }
                that.item.mediaActivityId = that.mediaActivityId
                that.item.mpAuthConfigId = that.mpAuthConfigId
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.item.replyContent = JSON.stringify(that.item.texts)
                        that.item.sort = that.sort;
                        mediaActivityApi.createMediaActivityText.call(that, that.item, function (res) {
                            that.item.id = res.result.item.id;
                            that.item.taokeAccountId = res.result.item.taokeAccountId;
                        })
                    } else {
                        return false;
                    }
                });

            }
        }

    }
</script>
<style lang="scss">
    .texts {

        .title {
            margin: 10px 0;
        }

        .item {
            .input {
                width: 300px;
            }

            button {
                margin-left: 10px;
            }
        }

    }
</style>
